import { APIResponse, PaginatedResponse } from './client';
import { apiClient } from './client';

export interface Notification {
  id: number;
  type: string | null;
  profileid: number;
  url: string | null;
  message: string;
  read: boolean;
  description: string | null;
  isactive: boolean;
  isdeleted: boolean;
  createdon: string;
  createdby: number | null;
  lastactivityon: string | null;
  lastactivityby: number | null;
}

export interface NotificationQueryOptions {
  searchText?: string;
  skip?: number;
  perPage?: number;
  filters?: any;
}

export class NotificationAPI {
  static async getAll(options?: NotificationQueryOptions): Promise<APIResponse<PaginatedResponse<Notification>>> {
    return apiClient.get<PaginatedResponse<Notification>>('/notifications', options);
  }

  static async markAsRead(id: number): Promise<APIResponse<Notification>> {
    return apiClient.patch<Notification>(`/notifications/${id}`, { read: true });
  }

  static async markAllAsRead(): Promise<APIResponse<void>> {
    return apiClient.patch<void>('/notifications/mark-all-read');
  }

  static async getUnreadCount(): Promise<APIResponse<{ count: number }>> {
    return apiClient.get<{ count: number }>('/notifications/unread-count');
  }

  static async haveUnreadMessage(): Promise<APIResponse<Notification[]>> {
    return apiClient.get<Notification[]>('/notifications/unread');
  }

  static async delete(id: number): Promise<APIResponse<void>> {
    return apiClient.delete<void>(`/notifications/${id}`);
  }

  static async getByType(type: string): Promise<APIResponse<Notification[]>> {
    return apiClient.get<Notification[]>(`/notifications/type/${type}`);
  }
}
